import { render } from "./create-desc.vue?vue&type=template&id=32272410"
import script from "./create-desc.vue?vue&type=script&lang=js"
export * from "./create-desc.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__